﻿<script>
	export let id;
	export let value = "";
	export let label;
	export let optionList;
	export let textProperty = "name";
	export let valueProperty = "id";
	export let showHead = true;
	export let disabled = null;
	export let readonly = null;
	export let required = null;
	export let errorMessageTarget = null;
</script>

{#if label}
	<label for={id} class:isrequired={required}>{label}</label>
{/if}

<select {id} bind:value {disabled} {readonly} {required} class="form-control" data-bouncer-target={errorMessageTarget}>
	{#each optionList as item}
		<option value={item[valueProperty]} selected={item[valueProperty] == value}>{item[textProperty]}</option>
	{/each}
</select>
